import { motion } from 'framer-motion';
import { EASE_REFINED } from './constants';

export default function FormSuccessPanel({ title, message }) {
  return (
    <motion.div
      className="glass-panel form-success-panel"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: EASE_REFINED }}
      role="status"
    >
      <div className="form-success-panel__icon" aria-hidden="true">
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
          <path
            d="M4.5 11l5 5.5 8-9"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <h3 className="form-success-panel__title">{title}</h3>
      <p className="form-success-panel__message">{message}</p>
    </motion.div>
  );
}
